<template>
  <div class="clearfix">
    <div style="clear: both;"></div>
    <section class="pagination-container" v-show="pageModal.total > 10">
      <span class="page-total">共{{totalPage}}页</span>
      <a href="javascript:;" class="btn-prev" :class="{'btn-disabled': pageModal.pageNo === 1}" @click="prev(pageModal.pageNo - 1)">
        <i class="iconfont icon-rule-arrowdown"></i>
      </a>
      <a href="javascript:;" class="btn-page" v-for="(item) in startList" :key="item" :class="{'active': pageModal.pageNo === item }" @click="handlePage(item)">
        {{item}}
      </a>
      <span class="btn-page dismiss" v-if="middleList.length">...</span>
      <a href="javascript:;" class="btn-page" v-for="(item) in middleList" :key="item" :class="{'active': pageModal.pageNo === item }" @click="handlePage(item)">
        {{item}}
      </a>
      <span class="btn-page dismiss" v-if="endList.length">...</span>
      <a href="javascript:;" class="btn-page" v-for="(item) in endList" :key="item" :class="{'active': pageModal.pageNo === item }" @click="handlePage(item)">
        {{item}}
      </a>
      <a href="javascript:;" class="btn-next" :class="{'btn-disabled': pageModal.pageNo === totalPage}" @click="prev(pageModal.pageNo + 1)">
        <i class="iconfont icon-rule-arrowdown"></i>
      </a>
      <div class="drop-down">
        <p>{{pageModal.pageSize}}条/页
          <i class="iconfont icon-rule-arrowdown"></i>
        </p>
        <ul>
          <li v-for="(item) in pageSizeList" :key="`pageSizeList-${item}`" :class="{'active': pageModal.pageSize === item}" @click="selectPageSize(item)">{{item}}条/页</li>
        </ul>
      </div>
      <div class="go-to">
        前往
        <input v-model="goTo" @blur="handleGoto()"/>
        页
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    maxCount: {
      type: [Number, String],
      default: 7
    },
    pageModal: {
      type: Object,
      default () {
        return {
          pageNo: 1,
          pageSize: 10,
          total: 0
        }
      }
    },
    pageSizeList: {
      type: Array,
      default () {
        return [10, 20, 30, 40]
      }
    }
  },
  computed: {
    totalPage () {
      const {
        pageSize,
        total
      } = this.pageModal
      return Math.ceil(total / pageSize)
    },
    startList () {
      const {
        maxCount
      } = this
      const pages = []
      const {
        pageNo
      } = this.pageModal
      if (this.totalPage > maxCount) {
        if (pageNo <= Math.ceil(maxCount/2)) {
          for (let i = 1; i <= maxCount - 1; i++) {
            pages.push(i)
          }
        } else {
          for (let i = 1; i <= 1; i++) {
            pages.push(i)
          }
        }
      } else if (this.totalPage <= maxCount) {
        for (let i = 1; i <= this.totalPage; i++) {
            pages.push(i)
          }
      }
      return pages
    },
    middleList () {
      const {
        maxCount
      } = this
      const pages = []
      const {
        pageNo
      } = this.pageModal
      if (this.totalPage > maxCount) {
        if (pageNo <= Math.ceil(maxCount/2)) {
          for (let i = pageNo - (maxCount/2); i <= maxCount - 1; i++) {
            // pages.push(i)
          }
        } else {
          for (let i = 1; i <= this.totalPage; i++) {
            if ((i <= pageNo - Math.floor(maxCount/2) && i < this.totalPage - Math.ceil(maxCount/2)) || i >= Math.floor(pageNo + (maxCount/2)) || i > this.totalPage) {
              continue
            }
            pages.push(i)
          }
        }
      }
      return pages
    },
    endList () {
      const {
        maxCount
      } = this
      const pages = []
      const {
        pageNo
      } = this.pageModal
      if (this.totalPage > maxCount) {
        if (pageNo <= Math.ceil(maxCount/2)) {
          pages.push(this.totalPage)
        } else if (pageNo + Math.floor(maxCount/2) <= this.totalPage) {
          pages.push(this.totalPage)
        }
      }
      return pages
    }
  },
  data () {
    return {
      goTo: this.pageModal.pageNo
    }
  },
  methods: {
    selectPageSize (pageSize) {
      this.$emit('update:pageModal', {
        pageNo: 1,
        pageSize,
        total: this.pageModal.total
      })
      setTimeout(() => {
        this.$emit('query')
      }, 1)
    },
    handlePage (pageNo) {
      if (pageNo === this.pageModal.pageNo) {
        return
      }
      this.$emit('update:pageModal', {
        pageNo,
        pageSize: this.pageModal.pageSize,
        total: this.pageModal.total
      })
      setTimeout(() => {
        this.$emit('query')
      }, 1)
    },
    prev (pageNo)  {
      if (pageNo < 1 || pageNo > this.totalPage) {
        return
      }
      this.$emit('update:pageModal', {
        pageNo,
        pageSize: this.pageModal.pageSize,
        total: this.pageModal.total
      })
      setTimeout(() => {
        this.$emit('query')
      }, 1)
    },
    handleGoto () {
      if (this.goTo > this.totalPage || parseInt(this.goTo) || parseInt(this.goTo) <= 0) {
        this.goTo = 1
      }
      this.$emit('update:pageModal', {
        pageNo: this.goTo,
        pageSize: this.pageModal.pageSize,
        total: this.pageModal.total
      })
      setTimeout(() => {
        this.$emit('query')
      }, 1)
    }
  },
  watch: {
    pageModal: {
      handler(newVal){
        this.goTo = newVal.pageNo
      },
      deep:true
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #666;
  text-align: left;
  font-weight: 400;
  text-align: right;
  padding-right: 10px;
  padding-bottom: 15px;
  padding-top: 15px;
  .page-total {
    display: inline-block;
    padding: 5px 10px;
    vertical-align: top;
    line-height: 30px;
    box-sizing: border-box;
  }
  .btn-prev {
    display: inline-block;
    padding: 6px 5px 5px;
    vertical-align: top;
    margin: 3px;
    min-width: 32px;
    height: 32px;
    box-sizing: border-box;
    text-align: center;
    background: #FFFFFF;
    border: 1px solid #B8B8B8;
    border-radius: 2px;
    i {
      display: inline-block;
      transform:rotate(90deg);
      position: relative;
      top: -2px;
      color: #848585;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .btn-next {
    display: inline-block;
    padding: 6px 5px 5px;
    vertical-align: top;
    margin: 3px;
    min-width: 32px;
    height: 32px;
    box-sizing: border-box;
    text-align: center;
    background: #FFFFFF;
    border: 1px solid #B8B8B8;
    border-radius: 2px;
    i {
      display: inline-block;
      transform:rotate(-90deg);
      position: relative;
      top: -2px;
      color: #848585;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  .dismiss {
    border: none!important;
    min-width: 5px!important;
    padding: 6px 2px 5px!important;
  }
  .btn-page {
    display: inline-block;
    padding: 6px 5px 5px;
    vertical-align: top;
    margin: 3px;
    min-width: 32px;
    height: 32px;
    box-sizing: border-box;
    text-align: center;
    background: #FFFFFF;
    border: 1px solid #B8B8B8;
    border-radius: 2px;
    color: #848585;
    font-weight: 400;
    &.active {
      background: #F32B80;
      border: 1px solid #CD2A78;
      color: #fff;
    }
  }
  .btn-disabled {
    border: 1px solid #ddd;
    color:#ddd!important;
    cursor: no-drop;
    i {
      color:#ddd!important;
    }
  }
  .drop-down {
    display: inline-block;
    vertical-align: top;
    margin: 3px;
    box-sizing: border-box;
    position: relative;
    background: #FFFFFF;
    border: 1px solid #B8B8B8;
    border-radius: 2px;
    line-height: 28px;
    height: 32px;
    padding: 0 6px;
    color: #666;
    font-weight: 400;
    &:hover {
      ul {
        display: block;
      }
    }
    ul {
      display: none;
      position: absolute;
      width: 100%;
      left:0;
      top: 100%;
      margin-left: -1px;
      background: #FFFFFF;
      border: 1px solid #B8B8B8;
      border-radius: 2px;
      li {
        text-align: left;
        padding-left: 6px;
        cursor: pointer;
        &:hover {
          background: #F10180;
          color: #fff;
        }
      }
    }
  }
  .go-to  {
    display: inline-block;
    margin: 3px 20px;
    vertical-align: top;
    line-height: 32px;
    input {
      vertical-align: top;
      box-sizing: border-box;
      background: #FFFFFF;
      border: 1px solid #B8B8B8;
      border-radius: 2px;
      padding: 0 10px;
      line-height: 30px;
      height: 32px;
      max-width: 48px;
      text-align: center;
      outline: none;
      position: relative;
      color: #848585;
      text-align: center;
      font-weight: 400;
      margin: 0 3px;
    }
  }
}
</style>
